module.exports = __webpack_public_path__ + "img/icon1.cac06c3a.png";